import React, { useEffect, useState } from "react";
import { getAllSubsites, allSubsites, subsiteTotalCount } from '../../reducers/subsite';
import { reloadUser } from '../../reducers/auth';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MSMPagination from '../MSMPagination';
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { useNavigate } from 'react-router-dom';
import { Diagram2 } from 'react-bootstrap-icons';
import Form from "react-bootstrap/Form";
import { Search } from 'react-bootstrap-icons';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const AdminSubsites = () => {
  const subsites = useSelector(allSubsites);
  const subsiteStatus = useSelector(state => state.subsite.status);
  const subsiteTotal = useSelector(subsiteTotalCount);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [range, setRange] = useState([1, 10]);
  const [reload, setReload] = useState(false);
  const [resetPagination, setResetPagination] = useState(false);
  let perPage = 10;
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');

  const fetchSubsites = (nextRange = range, nextSearch = searchTerm, nextActive = activeFilter) => {
    dispatch(getAllSubsites({ range: nextRange, filter: nextSearch, active: nextActive }));
  };

  useEffect(() => {
    if (subsiteStatus === 'idle') {
      fetchSubsites();
    }
  }, [subsiteStatus, dispatch]);

  useEffect(() => {
    fetchSubsites();
    dispatch(reloadUser());
  }, [range, reload, dispatch]);

  let content = "";

  if (subsiteStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (subsiteStatus === 'succeeded') {
    if (subsites && subsites.length > 0) {
      content = subsites.map(subsite => (
        <div
          key={subsite.id}
          className="user-list-item"
          onClick={() => navigate(`/admin/subsite/${subsite.id}`)}
          style={{ cursor: 'pointer' }}
        >
          <div style={{ flex: 1, backgroundColor: "#000000", height: 100, alignContent: "center", textAlign: "center", margin: 10 }}>
            <img width={90} src={`${BACKEND_URL}/uploads/subsites/${subsite.logoFilename}`} alt="" />
          </div>
          <div className="details" style={{ flex: 3 }}>
            <span className="title">Subsite:</span> {subsite.subsiteName}{' '}
            <Badge bg={subsite.active ? 'success' : 'secondary'}>
              {subsite.active ? 'Active' : 'Inactive'}
            </Badge>
            <br />
            <span className="title">Abbr:</span> {subsite.abbreviation}<br />
            <span className="title">POC:</span> {subsite.internalPOCs}
          </div>
        </div>
      ));
    } else {
      content = <div>No subsites</div>
    }
  } else if (subsiteStatus === 'failed') {
    content = <div>error</div>
  }

  const reloadData = (nextRange) => {
    setRange(nextRange);
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());
    setSearchTerm(formDataObj.searchTerm || '');
    setResetPagination(!resetPagination);
    fetchSubsites(range, formDataObj.searchTerm || '', activeFilter);
  }

  const handleActiveFilterChange = (e) => {
    const value = e.target.value;
    setActiveFilter(value);
    setResetPagination(!resetPagination);
    fetchSubsites(range, searchTerm, value);
  }

  return (
    <div className="page_container">
      <Button onClick={() => navigate('/admin/subsite/new')}><Diagram2 /> Add Subsite</Button>
      <Row className="align-items-end mt-3 mb-2 g-2">
        <Col md={6}>
          <Form noValidate onSubmit={handleSearchSubmit}>
            <Form.Group className="nav-form" controlId="subsiteSearch">
              <Form.Control type="text" placeholder="Search" name="searchTerm" defaultValue={searchTerm} />
              <Button variant="secondary" type="submit">
                <Search />
              </Button>
            </Form.Group>
          </Form>
        </Col>
        <Col md={3}>
          <Form.Group controlId="subsiteActiveFilter">
            <Form.Label className="mb-1">Status</Form.Label>
            <Form.Select value={activeFilter} onChange={handleActiveFilterChange}>
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <MSMPagination reload={reloadData} perPage={perPage} total={subsiteTotal} reset={resetPagination} />
      {content}
    </div>
  );
};
export default AdminSubsites;
